import { render } from "./StaffEstablishmentHub.vue?vue&type=template&id=0132f0a6&scoped=true"
import script from "./StaffEstablishmentHub.vue?vue&type=script&lang=js"
export * from "./StaffEstablishmentHub.vue?vue&type=script&lang=js"

import "./StaffEstablishmentHub.vue?vue&type=style&index=0&id=0132f0a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0132f0a6"]])

export default __exports__